import { Link } from 'react-router-dom';
import css from '../details/details.module.scss';
import { ContactBlock } from 'src/types';
import { CONTACTS } from 'src/constants/routes';

interface BlockFilterProps {
  blocks: ContactBlock[];
  selectedBlock?: string;
}

function BlockChips({ blocks, selectedBlock }: Readonly<BlockFilterProps>) {
  return (
    <div className={css.blockChips}>
      <div className={css.chips}>
        {blocks.map((block: ContactBlock) => (
          <Link
            to={`/${CONTACTS.relativePath}/${block.slug}`}
            className={selectedBlock?.includes(block.slug) ? css.active : ''}
            key={block.id}>
            {block.title}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default BlockChips;
